/**
 * Generate code snippets for local-to-local (embedded) deployment
 */

import { WorkflowParameter, WorkflowImage } from "./types";

export function generateLocalLocalCode(
    workflowName: string,
    workspaceUrl: string,
    apiKey: string,
    workflowParameters: WorkflowParameter[],
    workflowImages: WorkflowImage[],
    localDeployUrl: string
): string {
    const pythonImageString = workflowImages
        .map((image) => `        "${image.name}": "YOUR_IMAGE.jpg"`)
        .join(",\n");

    const pythonParameterString = workflowParameters
        .map((param) => {
            const value =
                param.type === "boolean"
                    ? param.parsed_value
                        ? "True"
                        : "False"
                    : JSON.stringify(param.parsed_value);
            return `        "${param.name}": ${value}`;
        })
        .join(",\n");

    return `

You're currently running on a local Inference server.
To integrate your Workflow into an application, ensure the client machine has
the latest <code>inference_sdk</code> installed:

\`\`\`bash
pip install -U inference-sdk
\`\`\`

Then, you can run the following code to process an image with your workflow:

\`\`\`python
# 1. Import the library
from inference_sdk import InferenceHTTPClient

# 2. Connect to your workflow
client = InferenceHTTPClient(
    api_url="${localDeployUrl}" # update to this server's IP if running on a different machine
)

# 3. Run your workflow on an image
result = client.run_workflow(
    workspace_name="${workspaceUrl}",
    workflow_id="${workflowName}"${
        workflowImages.length > 0
            ? `,
    images={
${pythonImageString} # Path to your image file
    }`
            : ""
    }${
        pythonParameterString
            ? `,
    parameters={
${pythonParameterString}
    }`
            : ""
    },
    use_cache=True # Speeds up repeated requests
)

# 4. Get your results
print(result)
\`\`\`
`;
}
